<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas30bg.svg" />

    <div
      class="pageElement text-box-a hover-animation-a"
      id="textBox01"
      style="background-image: url(/pages/img/sordocas/svgCas30Globe01.svg)"
    >
      <p class="textBase pageElement" id="textBox01Text">
        ¿Cómo hizo la princesa<br />
        para perder mil<br />
        perlas en el bosque?
      </p>
    </div>

    <p class="textBase pageElement" id="text01">
      La primera prueba<br>
      consistía en recoger<br>
      mil perlas que la<br>
      princesa Catalina había<br>
      perdido en el bosque.
    </p>

    <span class="normalTheme pageInstruction" style="left: 81px; top: 430px">
      <p>
        Inventen entre todos un episodio que cuente cómo se perdieron las<br />
        perlas del collar en el bosque.
      </p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 81px; top: 510px">
      <p>Dicten al maestro el episodio que inventaron.</p>
    </span>
    <span
      style="
        outline: 1px solid #a6a6a6;
        width: 840px;
        height: 225px;
        left: 65px;
        top: 535px;
        z-index: 2;
        position: absolute;
      "
    ></span>
    <saved-input-long
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      maxlength="250"
      style="line-height: 74px"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 45px;
  top: 54px;
}

#textBox01 {
  position: absolute;
  width: 266px;
  height: 154.45px;
  left: 385px;
  top: 116px;
}
#textBox01Text {
  position: absolute;
  width: 296px;
  height: 151px;
  left: -10px;
  top: 20px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #fbf8f8;
}
#text01 {
  position: absolute;
  left: 100px;
  top: 198px;
  text-align: center;
  font-size: 20px;
  line-height: 29px;
  transform: rotate(-1.0deg);
}
#inputField01 {
  position: absolute;
  width: 800px;
  height: 225px;
  left: 35px;
  top: 525px;
  margin-left: 50px;
  margin-top: 10px;
  font-size: 33px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2bb673;
  z-index: 10;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 110.mp4",
        "cas/Video 111.mp4",
        "cas/Video 112.mp4",
        "cas/Video 113.mp4",
        "cas/Video 114.mp4",
        "cas/Video 115.mp4",
      ],
    };
  },
};
</script>